import { isStandaloneWebphonePath } from "@/components/webphone/standalone.helpers"

const CHROME_EXTENSION_ORIGIN_PREFIX = "chrome-extension://"

export interface PostHogRuntimeContext {
  ancestorOrigins: string[]
  isFramed: boolean
  pathname: string
}

interface RuntimeLocationLike {
  ancestorOrigins?: ArrayLike<string>
  pathname?: string
}

interface RuntimeWindowLike {
  location?: RuntimeLocationLike
  self?: unknown
  top?: unknown
}

export function toPostHogRuntimeContext(windowLike: RuntimeWindowLike | undefined): PostHogRuntimeContext {
  const location = windowLike?.location

  return {
    pathname: location?.pathname ?? "",
    isFramed: windowLike?.self !== windowLike?.top,
    ancestorOrigins: location?.ancestorOrigins ? Array.from(location.ancestorOrigins) : [],
  }
}

export function isChromeExtensionEmbeddedStandaloneWebphone(context: PostHogRuntimeContext): boolean {
  return context.isFramed && isStandaloneWebphonePath(context.pathname) && context.ancestorOrigins.some((origin) => origin.startsWith(CHROME_EXTENSION_ORIGIN_PREFIX))
}

export function getPostHogPersistence(context: PostHogRuntimeContext): "localStorage" | "localStorage+cookie" {
  return isChromeExtensionEmbeddedStandaloneWebphone(context) ? "localStorage" : "localStorage+cookie"
}

export function shouldForcePostHogSessionRecording(context: PostHogRuntimeContext): boolean {
  return isChromeExtensionEmbeddedStandaloneWebphone(context)
}
